import { convertToNormalCase } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import { localeMeta } from '@sohanscript/i18n/locale-meta';
import { formatNumber } from '@sohanscript/lib/utils/format';
import {
	ContributionGraph,
	type ContributionGraphLabels,
} from '@sohanscript/ui/contribution-graph';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { api } from '@/lib/trpc/client';
import { ReadmeContent } from './-components/readme-content';

const REPO = 'sohanemon';

export const Route = createFileRoute('/_main/readme/sohanemon')({
	component: SohanemonReadmePage,
	async loader({ context }) {
		await Promise.all([
			context.trpc.github.readme.ensureData({ repo: REPO }),
			context.trpc.github.contributions.ensureData(),
		]);
	},
	head: () => ({
		meta: [{ title: convertToNormalCase(REPO) }],
	}),
});

function SohanemonReadmePage() {
	const [data] = api.github.contributions.useSuspenseQuery();
	const locale = localeMeta().locale;

	const labels = useMemo<ContributionGraphLabels>(
		() => ({
			caption: m.contributions_caption(),
			contribution: (count) =>
				count === 1
					? m.contributions_one()
					: m.contributions_many({ count: formatNumber(count) }),
			empty: m.contributions_none(),
			kicker: m.contributions_kicker(),
			legendLess: m.contributions_legend_less(),
			legendMore: m.contributions_legend_more(),
			summary: ({ days, total, from, to }) =>
				m.contributions_summary({
					days: formatNumber(days),
					from,
					to,
					total: formatNumber(total),
				}),
		}),
		[],
	);

	return (
		<>
			<div className="[&_#hi-icon]:inline-block [&_#hi-icon]:size-10 [&_#roadmap-stats>img]:mx-auto [&_#streak-stats>img]:mx-auto">
				<ReadmeContent repo={REPO} noToc />
			</div>
			<ContributionGraph
				className="max-w-4xl mx-auto"
				data={data}
				labels={labels}
				locale={locale}
			/>
			<style>
				{`
          #signal + table a {
            display: flex;
            justify-content: center;
          }

          #skills + table img {
            margin-inline: auto;
          }
`}
			</style>
		</>
	);
}
